import { LeisureType } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const isBeachHoliday = (searchParams: SearchParams): boolean =>
  searchParams[URLParameters.DESTINATION] === LeisureType.BEACH;
